import { t } from 'i18next';
import { START_CHAIM_AUDIO } from './utils/chimeAudio';

export const LOCK_DYN = [
  { type: 'lockYn', lockYn: 'A', lName: '전체' },
  { type: 'lockYn', lockYn: 'Y', lName: '잠금' },
  { type: 'lockYn', lockYn: 'N', lName: '미잠금' },
];

export const USE_DYN = [
  { type: 'useYn', useYn: 'A', cdName: '전체' },
  { type: 'useYn', useYn: 'Y', cdName: '사용' },
  { type: 'useYn', useYn: 'N', cdName: '미사용' },
];

export const USE_YN = [
  { type: 'useYn', useYn: 'Y', cdName: '사용' },
  { type: 'useYn', useYn: 'N', cdName: '미사용' },
];

export const SELECT_HNAME_OR_ADMINUSERNAME = [
  { type: 'nameType', nameType: 'hName', cdName: '본사명' },
  { type: 'nameType', nameType: 'userName', cdName: '관리자명' },
];

export const SELECT_CNAME_OR_ADMINUSERNAME = [
  { type: 'nameType', nameType: 'cName', cdName: '사내명' },
  { type: 'nameType', nameType: 'userName', cdName: '관리자명' },
];

export const SELECT_HNAME_OR_SALESUSERNAME = [
  { type: 'nameType', nameType: 'hName', cdName: '본사명' },
  { type: 'nameType', nameType: 'userName', cdName: '영업 담당자명' },
];

export const SELECT_SNAME_OR_ADMINUSERNAME = [
  { type: 'nameType', nameType: 'sName', cdName: '현장명' },
  { type: 'nameType', nameType: 'userName', cdName: '관리자명' },
];

export const SELECT_SNAME_OR_HNAME = [
  { type: 'nameType', nameType: 'sName', cdName: '현장명' },
  { type: 'nameType', nameType: 'hName', cdName: '본사명' },
];

// CCTV 카메라 스트림항목
export const CAMERA_STREAM = [
  { type: 'stream', stream: '2', uName: 'Sub' },
  { type: 'stream', stream: '1', uName: 'Main' },
  { type: 'stream', stream: '3', uName: 'Third' },
];

// 근로자 근로상태
export const WORK_STATUS_SEARCH = [
  { type: 'wWorkstatus', wWorkstatus: 'A', cdName: '전체' },
  { type: 'wWorkstatus', wWorkstatus: 'I', cdName: '재직' },
  { type: 'wWorkstatus', wWorkstatus: 'R', cdName: '퇴직' },
  { type: 'wWorkstatus', wWorkstatus: 'D', cdName: '삭제' },
];

// 근로자 근로상태2 (대기포함)
export const WORK_STATUS_SEARCH2 = [
  { type: 'wWorkstatus', wWorkstatus: 'A', cdName: '전체' },
  { type: 'wWorkstatus', wWorkstatus: 'I', cdName: '재직' },
  { type: 'wWorkstatus', wWorkstatus: 'R', cdName: '퇴직' },
  { type: 'wWorkstatus', wWorkstatus: 'D', cdName: '삭제' },
  { type: 'wWorkstatus', wWorkstatus: 'T', cdName: '대기' },
];

// 직무스트레스 결과
export const WORKER_STRESS_RESULT = [
  { type: 'stressResult', stressResult: 'A', cdName: '전체' },
  { type: 'stressResult', stressResult: '하위 25%', cdName: '하위 25%' },
  { type: 'stressResult', stressResult: '하위 50%', cdName: '하위 50%' },
  { type: 'stressResult', stressResult: '상위 50%', cdName: '상위 50%' },
  { type: 'stressResult', stressResult: '상위 25%', cdName: '상위 25%' },
];

// 근로자 근로상태 (인풋)
export const WORK_STATUS_INPUT = [
  { subCd: 'I', cdName: '재직' },
  { subCd: 'R', cdName: '퇴직' },
  { subCd: 'D', cdName: '삭제' },
  { subCd: 'T', cdName: '대기' },
];

// 근로자 성별
export const SEX = [
  { type: 'sex', value: '', cdName: '선택' },
  { type: 'sex', value: '1', cdName: '남성' },
  { type: 'sex', value: '2', cdName: '여성' },
];

// 근로자 외국인 유무
export const FOREIGN_YN = [
  { type: 'wForeignyn', wForeignyn: 'A', cdName: '전체' },
  { type: 'wForeignyn', wForeignyn: 'Y', cdName: '외국인' },
  { type: 'wForeignyn', wForeignyn: 'N', cdName: '내국인' },
];

// 근로자 외국인 유무
export const FOREIGN_YN_INPUT = [
  { type: 'wForeignyn', wForeignyn: '', cdName: '선택' },
  { type: 'wForeignyn', wForeignyn: 'Y', cdName: '외국인' },
  { type: 'wForeignyn', wForeignyn: 'N', cdName: '내국인' },
];

// 소음 측정 항목
export const SOUND_UNIT = [
  { type: 'soundUnit', soundUnit: 'A', cdName: '전체' },
  { type: 'soundUnit', soundUnit: 'sound', cdName: '순간소음' },
  { type: 'soundUnit', soundUnit: 'leq1Min', cdName: '1분 등가소음' },
  { type: 'soundUnit', soundUnit: 'leq5Min', cdName: '5분 등가소음' },
];

// CCTV 연결설정
export const CCTV_MODE = [
  { type: 'cctvProtocol', cctvProtocol: '0', cdName: '미선택' },
  { type: 'cctvProtocol', cctvProtocol: '1', cdName: 'WEB SDK' },
  { type: 'cctvProtocol', cctvProtocol: '2', cdName: 'RTSP' },
];

// 화면색상 모드
export const SCREEN_COLOR_MODE = [
  { type: 'bScreenMode', bScreenMode: '1', cdName: 'LIGHT' },
  { type: 'bScreenMode', bScreenMode: '2', cdName: 'DARK' },
];

// CCTV 통신 프로토콜
export const PROTOCOL = [
  { type: 'protocol', protocol: 'HTTP', cdName: 'HTTP' },
  { type: 'protocol', protocol: 'HTTPS', cdName: 'HTTPS' },
];

// 언어 설정 (상황판)
export const BOARD_LANG = [
  { type: 'bLangMode', bLangMode: '1', cdName: 'ko-KR' },
  { type: 'bLangMode', bLangMode: '2', cdName: 'en-US' },
  { type: 'bLangMode', bLangMode: '3', cdName: 'vi-VN' },
];

export const preJobTypeList = [
  { type: 'jobtype', jobtype: 'N', cdName: '직종만 사용' },
  { type: 'jobtype', jobtype: 'Y', cdName: '공종+직종 사용' },
];

// 근로자 근로상태
export const BLACK_YN = [
  { type: 'blackYn', blackYn: 'A', cdName: '전체' },
  { type: 'blackYn', blackYn: 'Y', cdName: '적용' },
  { type: 'blackYn', blackYn: 'N', cdName: '해제' },
];

// 근로자 근로상태
export const BLACK_YN_INPUT = [
  { type: 'blackYn', blackYn: 'Y', cdName: '적용' },
  { type: 'blackYn', blackYn: 'N', cdName: '해제' },
];

// 근로자 근로상태
export const SEARCH_CATEGORY = [
  { type: 'category', category: 'before', cdName: '출생일 이전' },
  { type: 'category', category: 'middle', cdName: '출생기간 선택' },
];

// 센서관리
export const SENSOR_TIME = [
  { type: 'time', time: '1', cdName: '시간' },
  { type: 'time', time: '2', cdName: '상세' },
];

// 안전지적 조치여부
export const SRSUM_YN = [
  { type: 'srSumYn', srSumYn: 'A', cdName: '전체' },
  { type: 'srSumYn', srSumYn: 'Y', cdName: '조치' },
  { type: 'srSumYn', srSumYn: 'N', cdName: '미조치' },
];

// 방송테스트
export const BROADCASTING = [
  { type: 'broadcasting', broadcasting: t('마이크'), cdName: t('마이크') },
  { type: 'broadcasting', broadcasting: t('사운드'), cdName: t('사운드') },
];

// 긴급 상황 조치 상태 코드
export const ACTION_STATUS = [
  { type: 'actionStatus', actionStatus: 'A', cdName: '전체' },
  { type: 'actionStatus', actionStatus: '0', cdName: '미조치' },
  { type: 'actionStatus', actionStatus: '1', cdName: '조치중' },
  { type: 'actionStatus', actionStatus: '2', cdName: '조치완료' },
];

// 긴급 상황 조치 상태 코드
export const ACTION_STATUS2 = [
  { type: 'actionStatus', actionStatus: '0', cdName: '미조치' },
  { type: 'actionStatus', actionStatus: '1', cdName: '조치중' },
  { type: 'actionStatus', actionStatus: '2', cdName: '조치완료' },
];

// 긴급 상황 알람 중단 시간 설정
export const ALARM_OFF_PERIOD = [
  { type: 'alarmOffPeriod', alarmOffPeriod: 0, cdName: '시간 선택' },
  { type: 'alarmOffPeriod', alarmOffPeriod: 600, cdName: '10분 동안' },
  { type: 'alarmOffPeriod', alarmOffPeriod: 1800, cdName: '30분 동안' },
  { type: 'alarmOffPeriod', alarmOffPeriod: 3600, cdName: '1시간 동안' },
  { type: 'alarmOffPeriod', alarmOffPeriod: 7200, cdName: '2시간 동안' },
  { type: 'alarmOffPeriod', alarmOffPeriod: 10800, cdName: '3시간 동안' },
  { type: 'alarmOffPeriod', alarmOffPeriod: 14400, cdName: '4시간 동안' },
  { type: 'alarmOffPeriod', alarmOffPeriod: 18000, cdName: '5시간 동안' },
  { type: 'alarmOffPeriod', alarmOffPeriod: -1, cdName: '사용자 지정 시간까지' },
];

// 수직구 방향 목록
export const TUNNEL_DIRECTION = [
  { type: 'tDirection', tDirection: 'F', cdName: '정방향' },
  { type: 'tDirection', tDirection: 'R', cdName: '역방향' },
];

// 다국어 TTS 음원파일 생성 (국내 건설현장 외국인 근로자 주요 언어 중심, Google Cloud TTS Standard 지원 언어)
// ※ 캄보디아(크메르어)·네팔어·미얀마어·스리랑카(싱할라어)·몽골어·우즈베크어는 Google TTS 미지원 → 영어/러시아어로 대체
export const TTS_LANGUAGES = [
  { type: 'lanCd', lanCd: 'ko-KR', cdName: '한국어' },
  { type: 'lanCd', lanCd: 'cmn-CN', cdName: '중국어(간체)' },
  { type: 'lanCd', lanCd: 'vi-VN', cdName: '베트남어' },
  { type: 'lanCd', lanCd: 'ru-RU', cdName: '러시아어' },
  { type: 'lanCd', lanCd: 'th-TH', cdName: '태국어' },
  { type: 'lanCd', lanCd: 'id-ID', cdName: '인도네시아어' },
  { type: 'lanCd', lanCd: 'bn-IN', cdName: '벵골어 (방글라데시)' },
  { type: 'lanCd', lanCd: 'fil-PH', cdName: '필리핀어' },
  { type: 'lanCd', lanCd: 'ur-IN', cdName: '우르두어 (파키스탄)' },
  { type: 'lanCd', lanCd: 'ms-MY', cdName: '말레이어' },
  { type: 'lanCd', lanCd: 'hi-IN', cdName: '힌디어 (인도)' },
  { type: 'lanCd', lanCd: 'en-US', cdName: '영어' },
];

export const bookmarkSelectBoxOptions = [
  { type: 'camList', camList: '', cdName: '즐겨찾기 선택' },
  { type: 'camList', camList: 'camList', cdName: '통합 즐겨찾기' },
  { type: 'camList', camList: 'camList1', cdName: '즐겨찾기 1' },
  { type: 'camList', camList: 'camList2', cdName: '즐겨찾기 2' },
  { type: 'camList', camList: 'camList3', cdName: '즐겨찾기 3' },
  { type: 'camList', camList: 'camList4', cdName: '즐겨찾기 4' },
  { type: 'camList', camList: 'camList5', cdName: '즐겨찾기 5' },
];

export const hBookmarkSelectBoxOptions = [
  { type: 'camList', camList: '', cdName: '즐겨찾기 선택' },
  { type: 'camList', camList: 'camList1', cdName: '즐겨찾기 1' },
  { type: 'camList', camList: 'camList2', cdName: '즐겨찾기 2' },
  { type: 'camList', camList: 'camList3', cdName: '즐겨찾기 3' },
  { type: 'camList', camList: 'camList4', cdName: '즐겨찾기 4' },
  { type: 'camList', camList: 'camList5', cdName: '즐겨찾기 5' },
];
export const streamSelectBoxOptions = [
  { type: 'stream', stream: 1, cdName: '메인 스트림' },
  { type: 'stream', stream: 2, cdName: '서브 스트림' },
];

// 근로자 안전교육 시험 결과
export const SAFEEDU_EXAM_RESULT = [
  { type: 'eduexamResult', eduexamResult: 'A', cdName: '전체' },
  { type: 'eduexamResult', eduexamResult: 'pass', cdName: '합격' },
  { type: 'eduexamResult', eduexamResult: 'nonPass', cdName: '불합격' },
];

// 보고서 - 결재라인 라인 구분
export const APPROVAL_LINE_GUBUN = [
  { type: 'lGubun', lGubun: 'A', cdName: '전체' },
  { type: 'lGubun', lGubun: '1', cdName: '보고' },
  { type: 'lGubun', lGubun: '2', cdName: '결재' },
];

// 최근 5년 연도
const toYear = new Date().getFullYear();
export const YEAR_LIST = [
  // { type: 'aYear', aYear: ``, cdName: `전체` },
  { type: 'aYear', aYear: `${toYear}`, cdName: `${toYear}` },
  { type: 'aYear', aYear: `${toYear - 1}`, cdName: `${toYear - 1}` },
  { type: 'aYear', aYear: `${toYear - 2}`, cdName: `${toYear - 2}` },
  { type: 'aYear', aYear: `${toYear - 3}`, cdName: `${toYear - 3}` },
  { type: 'aYear', aYear: `${toYear - 4}`, cdName: `${toYear - 4}` },
];

export const MONTH_LIST = [
  // { type: 'month', month: '', cdName: '전체' },
  { type: 'month', month: '01', cdName: '01' },
  { type: 'month', month: '02', cdName: '02' },
  { type: 'month', month: '03', cdName: '03' },
  { type: 'month', month: '04', cdName: '04' },
  { type: 'month', month: '05', cdName: '05' },
  { type: 'month', month: '06', cdName: '06' },
  { type: 'month', month: '07', cdName: '07' },
  { type: 'month', month: '08', cdName: '08' },
  { type: 'month', month: '09', cdName: '09' },
  { type: 'month', month: '10', cdName: '10' },
  { type: 'month', month: '11', cdName: '11' },
  { type: 'month', month: '12', cdName: '12' },
];

// 주간 요일별 목록
export const WEEK_LIST = [
  { type: 'week', v: '1', cdName: '월' },
  { type: 'week', v: '2', cdName: '화' },
  { type: 'week', v: '3', cdName: '수' },
  { type: 'week', v: '4', cdName: '목' },
  { type: 'week', v: '5', cdName: '금' },
  { type: 'week', v: '6', cdName: '토' },
  { type: 'week', v: '7', cdName: '일' },
];

// 일정 등록 시 구분 메뉴 목록
export const SCHEDULE_TAB_LIST = [
  { type: 'smGubun', v: '0', cdName: 'ALL', color: 'normal', colorCode: 'var(--zinc-500)' },
  // { type: 'smGubun', v: '1', cdName: '개인', color: 'blue', colorCode: 'var(--blue-500)' },
  // { type: 'smGubun', v: '2', cdName: '부서', color: 'yellow', colorCode: 'var(--yellow-500)' },
  { type: 'smGubun', v: '3', cdName: '일반', color: 'green', colorCode: 'var(--emerald-600)' },
  { type: 'smGubun', v: '4', cdName: '근태', color: 'red', colorCode: 'var(--rose-500)' },
  { type: 'smGubun', v: '5', cdName: '공통', color: 'violet', colorCode: 'var(--violet-500)' },
];

// 일정 등록 시 반복 주간 목록
export const SCHEDULE_LOOP_WEEK = [
  { type: 'wGubun', v: '0', cdName: '매주' },
  { type: 'wGubun', v: '1', cdName: '1주만' },
  { type: 'wGubun', v: '2', cdName: '2주만' },
  { type: 'wGubun', v: '3', cdName: '3주만' },
  { type: 'wGubun', v: '4', cdName: '4주만' },
  { type: 'wGubun', v: '5', cdName: '5주만' },
  { type: 'wGubun', v: '6', cdName: '마지막 주만' },
];

// 감지 알람 이벤트 목록
export const DETECT_EVENT_LIST = [
  {
    type: 'detectEvent',
    detectEvent: 'fireAudio',
    cdName: '화재감지',
  },
];

// 주간 요일 목록
export const INIT_WEEK_LIST = [
  { day: '월', dayOfWeek: 1, checked: false },
  { day: '화', dayOfWeek: 2, checked: false },
  { day: '수', dayOfWeek: 3, checked: false },
  { day: '목', dayOfWeek: 4, checked: false },
  { day: '금', dayOfWeek: 5, checked: false },
  { day: '토', dayOfWeek: 6, checked: false },
  { day: '일', dayOfWeek: 7, checked: false },
];

// 기본 센서 단위 목록
export const SENSOR_UNIT_LIST: Record<string, string> = {
  O2: '% vol',
  NO2: 'ppm',
  CO: 'ppm',
  CO2: 'ppm',
  H2S: 'ppm',
  CH4: '% LEL',
  CH2O: 'mg/m³',
  O3: 'ppm',
  ['PM2.5']: 'µg/m³',
  PM10: 'µg/m³',
  TEMP: '°C',
  HUMI: '%',
  VOC: 'Grade',
  PM1: 'µg/m³',
  FEELS: '°C',
};

// 센서 측정 범위 기본 설정
export const SENSOR_LIMIT_LIST: Record<string, { min: number; max: number }> = {
  NO2: { min: 0.1, max: 10 },
  CO: { min: 0, max: 1000 },
  CO2: { min: 0, max: 5000 },
  H2S: { min: 0, max: 100 },
  CH4: { min: 0, max: 100 },
  CH2O: { min: 0, max: 6.25 },
  O3: { min: 0, max: 10 },
  ['PM2.5']: { min: 0, max: 1000 },
  PM10: { min: 0, max: 1000 },
  TEMP: { min: -20, max: 65 },
  HUMI: { min: 0, max: 100 },
  VOC: { min: 0, max: 3 },
  PM1: { min: 0, max: 1000 },
  FEELS: { min: 31, max: 100 },
};

// 산소 범위 기본 설정
export const O2_RANGE = [
  { level: 0, lower: [-1, 19], upper: [-1, 22.5] }, // 좋음 (lower : 19.0(이상) / upper : 22.5(이하))
  { level: 1, lower: [19, 18.5], upper: [22.5, 23] }, // 주의 (lower : 19(미만) ~ 23.0(이하) / upper : 22.5(초과) ~ 23(이하))
  { level: 2, lower: [18.5, 18], upper: [23, 23.5] }, // 경고 (lower : 18.5(미만) ~ 18(이상) / upper : 23.0(초과) ~ 23.5(이하))
  { level: 3, lower: [18, -1], upper: [23.5, -1] }, // 위험 (lower : 18.0(미만) / upper : 23.5(초과))
];

export const hourList = Array.from({ length: 24 }, (_, i) => {
  const hourString = i.toString().padStart(2, '0'); // Pads the hour with a leading zero if it's less than 10
  return {
    type: 'hour',
    hour: hourString,
    cdName: hourString,
    cdSort: i + 101,
  };
});

export const hourList2 = Array.from({ length: 24 }, (_, i) => {
  const hourString = i.toString().padStart(2, '0'); // Pads the hour with a leading zero if it's less than 10
  return {
    label: hourString,
    value: hourString,
    cdSort: i,
  };
});

export const minList = Array.from({ length: 60 }, (_, i) => {
  const minString = i.toString().padStart(2, '0'); // Pads the hour with a leading zero if it's less than 10
  return {
    type: 'min',
    min: minString,
    cdName: minString,
    cdSort: i + 101,
  };
});

export const minList2 = Array.from({ length: 60 }, (_, i) => {
  const minString = i.toString().padStart(2, '0'); // Pads the hour with a leading zero if it's less than 10
  return {
    label: minString,
    value: minString,
    cdSort: i,
  };
});

export const elderlyAgeList = Array.from({ length: 30 }, (_, i) => {
  const elderlyAgeString = (i + 51).toString().padStart(2, '0'); // Pads the hour with a leading zero if it's less than 10
  return {
    type: 'elderlyAge',
    elderlyAge: elderlyAgeString,
    cdName: elderlyAgeString,
    cdSort: i + 101,
  };
});
const defaultObject = { type: 'elderlyAge', elderlyAge: '', cdName: '선택', cdSort: 0 };

export const elderlyAgeListWithDefault = [defaultObject, ...elderlyAgeList];

export const FLAG_NONE = 'N'; // 변화가 없을 때 플래그
export const FLAG_DELETE = 'D'; // 삭제 플래그
export const FLAG_CREATE_OR_UPDATE = 'Y'; // 신규 또는 수정 플래그

export const COMCD_MENU_GRANT = 'MENU_GRANT'; // 공통코드-메뉴화면 권한
export const COMCD_JONGMOK = 'JONGMOK'; // 공통코드-종목
export const COMCD_UPTAE = 'UPTAE'; // 공통코드-업태
export const COMCD_WORKERINPUT_SET = 'WORKERINPUT_SET'; // 공통코드-근로자 정보 입력
export const COMCD_S_STATUS = 'S_STATUS'; // 공통코드-현장상태
export const COMCD_USE_YN1 = 'USE_YN1'; // 공통코드-사용유무 미사용먼저
export const COMCD_S_VERSION = 'S_VERSION'; // 공통코드-현장 프로그램 버전
export const COMCD_USE_YN = 'USE_YN'; // 공통코드-사용유무
export const COMCD_LOCK_YN = 'LOCK_YN'; // 공통코드-잠금유무
export const COMCD_APPROVAL_YN = 'APPROVAL_YN'; // 공통코드-사용자 계정 승인여부
export const COMCD_REG_YN = 'REG_YN'; // 공통코드-승인여부
export const COMCD_INFRA = 'INFRA'; // 공통코드-건설사 인프라
export const LIST_COUNT = 'LIST_COUNT'; // 공통코드-검색줄수
export const NVR_GUBUN = 'NVR_GUBUN'; // 공통코드-NVR 제조사구분
export const BS_GUBUN = 'BS_GUBUN'; // 공통코드-방송 장비 제조사구분
export const USER_GRANT = 'USER_GRANT'; // 공통코드-사용자권한
export const DASHBOARD_GUBUN = 'DASHBOARD_GUBUN'; // 공통코드-대시보드 구분
export const COMCD_WORKER_GUBUN = 'WORKER_GUBUN'; // 공통코드-근로자 근로형태
export const COMCD_SENSOR_RANGE = 'SENSOR_RANGE'; // 센서구분 / 측정 범위용
export const COMCD_SENSOR_LIST = 'SENSOR_LIST'; // 공통코드-센서 목록
export const COMCD_EMERGENCY_GUBUN = 'EMERGENCY_GUBUN'; // 공통코드-긴급 상황 구분
export const COMCD_EMERGENCY_LEVEL = 'EMERGENCY_LEVEL'; // 공통코드-긴급 상황 LEVEL
export const COMCD_EMERGENCY_TYPE = 'EMERGENCY_TYPE'; // 공통코드-긴급 상황 유형
export const COMCD_STEMPLET_GUBUN = 'STEMPLET_GUBUN'; // 공통코드-스마트 안전교육 양식지 구분
export const COMCD_A_STATUS = 'A_STATUS'; // 공통코드-근태 승인 현황
export const COMCD_ATTENDANCE_GUBUN = 'ATTENDANCE_GUBUN'; // 공통코드-근태 구분
export const PREJOBTYPE_EXCEL_FORM_URL = `https://itlogs3server.s3.ap-northeast-2.amazonaws.com/ProSafe2/set/Excel/prosafeExcelUpload(%EA%B3%B5%EC%A2%85%2B%EC%A7%81%EC%A2%85).xlsx`; // (공종+직종용)근로자 간편등록 엑셀 지정양식 URL
export const JOBTYPE_EXCEL_FORM_URL = `https://itlogs3server.s3.ap-northeast-2.amazonaws.com/ProSafe2/set/Excel/prosafeExcelUpload(%EC%A7%81%EC%A2%85).xlsx`; // (직종용)근로자 간편등록 엑셀 지정양식 URL
export const SAFE_DEFAULT_COLOR = '#000';
// export const CCTV_VIEWER_PLUGIN_URL = `https://itlogs3server.s3.ap-northeast-2.amazonaws.com/ProSafe2/set/util/HCWebSDKPlugin.exe`; // WEB SDK 플러그인(구버전) 파일 다운로드 URL
export const CCTV_VIEWER_PLUGIN_URL = `https://itlogs3server.s3.ap-northeast-2.amazonaws.com/ProSafe2/set/util/WebPlugins.exe`; // WEB SDK 플러그인(신버전) 파일 다운로드 URL
export const WEBSDK_RESTART_PLUGIN_URL = `https://itlogs3server.s3.ap-northeast-2.amazonaws.com/ProSafe2/set/util/RestartPluginInstaller.exe`; // WEB SDK 재시작 파일 다운로드 URL

export const UNAUTHORIZED = '토큰 만료 다시 로그인 하세요';
export const ERROR = '요청하신 작업을 완수하지 못했습니다 잠시 후 다시 시도하세요';
export const EMAIL = '이메일을 입력하세요';
export const EMAIL_TYPE = '이메일 형식을 확인하세요';
export const PASSWORD = '비밀번호를 입력하세요';
export const PASSWORD_TYPE = '최소 9자리 이상, 영어 대문자, 소문자, 숫자, 특수문자 중 3종류를 조합하여 주세요';
export const PASSWORD_TYPE_SHORT_VERSION = '※ 최소 9자리 이상 : 영어 대문자, 소문자, 숫자, 특수문자 중 3종류 조합';
export const PASSWORD_WRONG = '비밀번호가 일치하지 않습니다';
export const MOBILE_PHONENUMBER = '휴대폰번호를 입력하세요';
export const MOBILE_PHONENUMBER_WRONG = '휴대폰번호를 확인하세요';
export const PHONENUMBER = '전화번호를 입력하세요';
export const PHONENUMBER_WRONG = '전화번호를 확인하세요';
export const ID = '아이디를 입력하세요';
export const ID_DUPLICATE = '아이디 중복검사를 완료하세요';
export const NAME = '성명을 입력하세요';
export const CHARACTER = '특수문자는 입력할 수 없습니다';
export const GRANT = '권한이 없습니다';
export const MOBILE_NOT_SUPPORT = '모바일 환경에서 지원되지 않는 화면입니다';

export const PMS_NORMAL_SUB_CODE = [
  {
    code: 'L',
    type: 'PART_CD',
    name: '부서명',
  },
  {
    code: 'M',
    type: 'POSITION_CD',
    name: '직급명',
  },
  {
    code: 'N',
    type: 'CONSTRUCTION_CD',
    name: '건설업종',
  },
  {
    code: 'O',
    type: 'CAM_C_CD',
    name: '관리회사명',
  },
];
export const SENSOR_HINT: any = {
  NO2: { level1: '6 ppm - 20 ppm (예:18)', level2: '21ppm - 50 ppm (예:48)', level3: '50 ppm 초과 (예:51)' },
  CO: { level1: '31 ppm - 100 ppm (예:95)', level2: '101 ppm - 500 ppm (예:490)', level3: '500 ppm 초과 (예:501)' },
  CO2: { level1: '1000 ppm - 2999 ppm (예:1500)', level2: '3000 ppm - 4999 ppm (예:4000)', level3: '5000 ppm 초과 (예:5001)' },
  H2S: { level1: '11 ppm - 20 ppm (예:15)', level2: '21 ppm - 50 ppm (예:40)', level3: '50 ppm 초과 (예:70)' },
  CH4: { level1: '5% - 7% (예:6)', level2: '8% - 10% (예:9)', level3: '10% 초과 (예:12)' },
  CH2O: { level1: '0.12 - 0.36 mg/m³ (예: 0.25)', level2: '0.37 - 0.60 mg/m³ (예: 0.45)', level3: '0.60 mg/m³ 초과 (예: 0.65)' },
  O3: { level1: '0.05 - 0.1 ppm (예: 0.09)', level2: '0.1 - 0.3 ppm (예: 0.25)', level3: '0.3 ppm 초과 (예: 0.35)' },
  ['PM2.5']: { level1: '35 - 75 µg/m³ (예: 70)', level2: '76 - 150 µg/m³ (예: 140)', level3: '150 µg/m³ 초과 (예: 160)' },
  PM10: { level1: '80 - 150 µg/m³ (예: 140)', level2: '151 - 300 µg/m³ (예: 290)', level3: '300 µg/m³ 초과 (예: 310)' },
  CRACK: { level1: '0.2 - 0.3 mm (예: 0.25)', level2: '0.3 - 0.5 mm (예: 0.4)', level3: '0.5 mm 이상 (예: 0.6)' },
  VOC: { level1: '1 Grade (예: 1)', level2: '2 Grade (예: 2)', level3: '3 Grade (예: 3)' },
  PM1: { level1: '11 - 25 µg/m³ (예: 20)', level2: '26 - 50 µg/m³ (예: 40)', level3: '50 µg/m³ 초과 (예: 51)' },
};

export const INIT_SCHEDULE: ISchedule = {
  smIdx: '',
  smGubun: '3',
  completeYn: 'N',
  travelYn: 'Y',
  smName: '',
  importantYn: 'N',
  loopYn: 'N',
  fontColor: '',
  backColor: '',
  isRepeatSchedule: false,
  orgRepeatSdate: '',
  setAttenders: [],
  hsCd1: '',
  hsCd2: '',
  alldayYn: 'Y',
  repeatsmIdx: '',
  wGubun: '',
  dGubun: [],
  csCd: '',
  contents: '',
  ccCd: '',
  dCd: '',
  fileList: [],
  deleteFileIndex: [],
  writer: '',
  wDate: '',
  editor: '',
  eDate: '',
  address1: '',
  latitude: '',
  longitude: '',
  users: [],
  siteManagerName: '',
  siteManagerPhone: '',
  siteManagerPartname: '',
};
export const INIT_USE_YN_A = { type: COMCD_USE_YN, [COMCD_USE_YN]: 'A', cdName: t('전체') };
export const INIT_USE_YN_Y = { type: COMCD_USE_YN, [COMCD_USE_YN]: 'Y', cdName: t('사용') };
export const INIT_LOCK_YN_A = { type: COMCD_LOCK_YN, [COMCD_LOCK_YN]: 'A', cdName: t('전체') };
export const INIT_LOCK_YN_N = { type: COMCD_LOCK_YN, [COMCD_LOCK_YN]: 'N', cdName: t('미잠금') };
export const INIT_APPROVAL_YN_A = { type: COMCD_APPROVAL_YN, [COMCD_APPROVAL_YN]: 'A', cdName: t('전체') };
export const INIT_CCTV_YN = { type: 'cctvYn', cctvYn: 'Y', cdName: t('사용') };
export const INIT_NCD_A = { type: 'nCd', nCd: 'A', cdName: '전체' };
export const INIT_CCD_A = { type: 'cCd', cCd: 'A', cdName: '전체' };
export const INIT_EQUIP_A = { type: 'equip', equip: 'A', cdName: '전체' };
export const INIT_TATCD_A = { type: 'tatCd', tatCd: 'A', cdName: '전체' };
export const INIT_TJC_A = { type: 'tjcCd', tjcCd: 'A', cdName: '전체' };
export const INIT_TES_A = { type: 'tesCd', tesCd: 'A', cdName: '전체' };
export const INIT_WORKER_STATUS = { type: 'wWorkstatus', wWorkstatus: 'I', cdName: t('재직') };
export const INIT_WORKER_STRESS_RESULT = { type: 'stressResult', stressResult: 'A', cdName: t('전체') };
export const TAREA_INNERTAB_NORMAL = 0; // 굴진/일반 정보
export const TAREA_INNERTAB_ATTEND = 1; // 근로자 출역 정보
export const TAREA_INNERTAB_LOCATION = 2; // 근로자/장비 위치 정보
export const TAREA_INNERTAB_MGAS = 3; // 유해 가스 정보
export const TAREA_INNERTAB_CCTV = 4; // CCTV 정보
export const TAREA_INNERTAB_EQUIP = 5; // 방송 장비 정보
export const TAREA_INNERTAB_REALTIME_ATTEND = 6; // 실시간 잔류 현황
export const SITE_DASHBOARD = 'b';
export const TAREA_DASHBOARD = 't';
export const COMPANY_DASHBOARD = 'r';
export const PTZDIRECTION = {
  UP: 1,
  DOWN: 2,
  LEFT: 3,
  RIGHT: 4,
  UPLEFT: 5,
  DOWNLEFT: 6,
  UPRIGHT: 7,
  DOWNRIGHT: 8,
  AUTO: 9,
};
export const CCTV_PLAY_BOTTOM_CONTROL_HEIGHT = 112; // CCTV 재생화면에서 하단 컨트롤바 높이
export const CCTV_REALTIME_BOTTOM_CONTROL_HEIGHT = 48; // CCTV 실시간보기에서 하단 컨트롤바 높이
export const CCTV_PLAY_SIDE_MENU_WIDTH = 336; // CCTV 재생화면에서 좌측메뉴 너비
export const INIT_CHECK_OPTION = [
  { key: 'workerInfoCheck', name: '근로자 정보', checked: false },
  { key: 'cCheck', name: '공통 양식지', checked: false },
  { key: 'jCheck', name: '직종별 양식지', checked: false },
  { key: 'muscularCheck', name: '근골격계 증상조사표', checked: false },
  { key: 'painCheck', name: '작업관련 통증 조사표', checked: false },
  { key: 'stressCheck', name: '직무스트레스 평가표', checked: false },
];
export const LANGUAGE_TYPES = {
  K: '한국어',
  E: '영어',
  C: '중국어(간체)',
  V: '베트남어',
  T: '태국어',
  M: '미얀마어',
  G: '캄보디아어',
  R: '러시아어',
  I: '인도네시아어',
  Y: '말레이시아어',
  Z: '카자흐스탄어',
  L: '몽골어',
};
export const INIT_START_HMS = { h: 0, m: 0, s: 0 };
export const INIT_HMS = { h: 0, m: 30, s: 0 };
export const INIT_END_HMS = { h: 23, m: 59, s: 59 };
export const SCHEDULE_TYPE_LIST = [
  { type: 'scheduleType', scheduleType: 'A', cdName: '전체' },
  // { type: 'scheduleType', scheduleType: '1', cdName: '개인' },
  // { type: 'scheduleType', scheduleType: '2', cdName: '부서' },
  { type: 'scheduleType', scheduleType: '3', cdName: '일반' },
  { type: 'scheduleType', scheduleType: '4', cdName: '근태' },
  { type: 'scheduleType', scheduleType: '5', cdName: '공통' },
] as const;

export const PROGRESS_TYPE_LIST = [
  { type: 'progressType', progressType: 'A', cdName: '전체' },
  { type: 'progressType', progressType: 'Y', cdName: '완료' },
  { type: 'progressType', progressType: 'N', cdName: '미완료' },
] as const;

export const COMPLETE_TYPE_LIST = [
  { type: 'completeCd', completeCd: 'A', cdName: '전체' },
  { type: 'completeCd', completeCd: 'Y', cdName: '완료' },
  { type: 'completeCd', completeCd: 'N', cdName: '미완료' },
] as const;

// 화재 경고음은 현재 방송 시작음과 같은 음원을 쓴다.
// URL 을 따로 하드코딩하면 요청 모드가 갈려 HTTP 캐시가 오염되므로 반드시 상수를 공유한다.
export const FIRE_ALERT_AUDIO = START_CHAIM_AUDIO;
export const VIDEO_TYPE_GENERAL = '1';
export const VIDEO_TYPE_JOB = '2';
export const VIDEO_TYPE_VISITOR = '3';
export const DASHBOARD_TYPE_LIST = [
  { index: 1, type: 'category', category: '날씨', cdName: '날씨', collapsed: false },
  { index: 2, type: 'category', category: '시계', cdName: '시계', collapsed: true },
  { index: 3, type: 'category', category: '출역', cdName: '출역', collapsed: true },
  { index: 4, type: 'category', category: '센서', cdName: '센서', collapsed: true },
  { index: 5, type: 'category', category: '현장 정보', cdName: '현장 정보', collapsed: true },
  { index: 6, type: 'category', category: '안전 정보', cdName: '안전 정보', collapsed: true },
  { index: 7, type: 'category', category: '터널', cdName: '터널', collapsed: true },
  { index: 8, type: 'category', category: '기타', cdName: '기타', collapsed: true },
];
export const WEATHER_ERROR_MESSAGE = '국가정보 자원관리원 화재로 인한 날씨 정보 일시 오류';
